"use client";
import React from "react";
import { m } from "motion/react";
import { cn } from "@/lib/utils";
import { IconArrowRight } from "@tabler/icons-react";
import MetallicPaintLogo from "@/components/metallic-paint-logo";

export default function CTASection() {
    return (
        <section className="py-32 bg-black relative overflow-hidden flex flex-col items-center justify-center border-t border-neutral-900">

            {/* Background Accent */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-midas-yellow-500/10 rounded-full blur-[120px] pointer-events-none" />

            <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
                <div className="mb-8 flex justify-center w-full">
                    <MetallicPaintLogo size="100px" />
                </div>
                <m.h2
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    className="text-4xl md:text-6xl font-bold text-white mb-8 tracking-tight"
                >
                    Não vendemos pacotes. <br />
                    Vendemos <span className="text-midas-yellow-500">ROI</span>.
                </m.h2>

                <m.p
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.1 }}
                    className="text-neutral-400 text-xl md:text-2xl mb-12 max-w-2xl mx-auto"
                >
                    Sua máquina está pronta para acelerar. Só falta ajustar a estratégia.
                </m.p>

                <m.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ delay: 0.2 }}
                >
                    <a href="#diagnostico" className="group relative inline-flex items-center justify-center px-8 py-5 text-lg font-bold text-black transition-all duration-200 bg-midas-yellow-500 rounded-full hover:bg-midas-yellow-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-midas-yellow-500 ring-offset-black">
                        <span>Agendar Diagnóstico Gratuito</span>
                        <IconArrowRight className="w-5 h-5 ml-2 -mr-1 transition-transform duration-200 group-hover:translate-x-1" />
                        <div className="absolute inset-0 rounded-full ring-2 ring-midas-yellow-500/50 animate-pulse" />
                    </a>
                </m.div>

                <p className="mt-8 text-neutral-400 text-sm">
                    Apenas 5 vagas para consultoria gratuita este mês.
                </p>
            </div>
        </section>
    );
}
